export const data = {
  loading: 'Loading data…',
  loadError: 'Failed to load data.',
  rangeEmpty: {
    title: 'No data to show',
    hint: 'Try a wider date range.',
    reset: 'View latest analysis',
  },
  runRange: {
    ariaLabel: 'Select date range',
    label: 'Date range',
    presets: {
      latest: 'Latest analysis',
      allTime: 'All time',
    },
  },
  export: {
    button: 'Download',
    ariaLabel: 'Download the data for the selected analysis or range',
    files: {
      prompts: 'prompts',
      responses: 'responses',
      sourceDomains: 'sources-domains',
      sourcePages: 'sources-pages',
      overview: 'overview',
    },
    values: {
      yes: 'Yes',
      no: 'No',
      competitor: 'Competitor',
      thirdParty: 'Third party',
    },
    columns: {
      prompt: 'Prompt',
      topic: 'Topic',
      tags: 'Tags',
      status: 'Status',
      mentionGap: 'Mention gap',
      mentionPercent: 'Mention %',
      competitorMentionPercent: 'Competitor mention %',
      citationGap: 'Citation gap',
      citationPercent: 'Citation %',
      competitorCitationPercent: 'Competitor citation %',
      sentimentPercent: 'Sentiment %',
      avgPosition: 'Avg. position',
      mentionChange: 'Mention change',
      sentimentChange: 'Sentiment change',
      impressions: 'Impressions',
      competition: 'Competition',
      monthlySearches: 'Monthly searches',
      totalValue: 'Total value',
      estimatedValueCaptured: 'Estimated value captured',
      language: 'Language',
      personas: 'Personas',
      totalResponses: 'Total responses',
      createdAt: 'Created',
      date: 'Date',
      monthlyQueries: 'Monthly searches',
      model: 'Model',
      promptType: 'Prompt type',
      basePrompt: 'Base prompt',
      promptVariation: 'Prompt variation',
      response: 'Response',
      mentioned: 'Mentioned',
      marketPosition: 'Market position',
      sentiment: 'Sentiment',
      competitorsMentioned: 'Competitors mentioned',
      sources: 'Sources',
      cited: 'Cited',
      attributedCitation: 'Attributed citation',
      persona: 'Persona',
      country: 'Country',
      location: 'Location',
      rank: 'Rank',
      domain: 'Domain',
      type: 'Type',
      responsesInfluenced: 'Responses influenced',
      urls: 'URLs',
      impressionsCaptured: 'Impressions captured',
      pageUrl: 'URL',
      rootDomain: 'Root domain',
      citations: 'Citations',
      sourceTags: 'Source tags',
    },
    overview: {
      sections: {
        kpis: 'KPIs',
        shareOfVoice: 'Share of Voice',
        shareOfVoiceByModel: 'Share of Voice by model',
        mentionRate: 'Mention rate (by period)',
        citationRate: 'Citation rate (by period)',
        heatmapMention: 'Heatmap — Mention (%)',
        heatmapCitation: 'Heatmap — Citation (%)',
        brandTraitsPositive: 'Brand traits — Positive',
        brandTraitsNegative: 'Brand traits — Negative',
      },
      columns: {
        metric: 'Metric',
        value: 'Value',
        competitor: 'Competitor',
        domain: 'Domain',
        sovPercent: 'SoV %',
        mentions: 'Mentions',
        model: 'Model',
        period: 'Period',
        brandPercent: 'Brand %',
        competitorsPercent: 'Competitors %',
        topic: 'Topic',
        trait: 'Trait',
        traitBrandPercent: 'Brand %',
        traitCompetitorPercent: 'Competitor %',
      },
    },
  },
  dashboard: {
    title: 'Data Dashboard',
    filters: {
      addFilter: 'Add filter',
      clearAll: 'Clear All',
      models: 'Models',
      isAnyOf: 'is any of',
      selected: 'selected',
      searchFields: 'Search fields...',
      searchModels: 'Search models...',
      selectAll: 'Select All',
      noData: 'No data',
      removeFilter: 'Remove filter',
      topicsAndPrompts: 'Topics & Prompts',
      promptTags: 'Prompt Tags',
      searchTopics: 'Search topics and prompts...',
      searchTags: 'Search prompt tags...',
      prompts: 'Prompts',
      competitors: 'Competitors',
      searchCompetitors: 'Search competitors...',
    },
    kpis: {
      responsesAnalyzed: 'Responses Analyzed',
      sourcesTracked: 'Sources Tracked',
    },
    shareOfVoice: {
      title: 'Share of Voice',
      subtitle: 'Brand and competitor visibility across tracked responses.',
      tooltip: {
        shareLabel: 'Share',
        mentionsLabel: 'Mentions',
      },
    },
    shareOfVoiceByModel: {
      title: 'Share of Voice by Model',
      subtitle: 'Visibility split across AI models and answer surfaces.',
      tooltip: {
        shareLabel: 'Share',
        mentionsLabel: 'Mentions',
      },
    },
    mentionRate: {
      title: 'Relative Mention Rate',
      subtitle: 'Brand mention rate versus competitors in relevant responses.',
      averageLabel: 'average mention rate',
      detailedCaption: '{{mentions}} mentions in {{responses}} relevant responses',
    },
    absoluteMentionRate: {
      title: 'Absolute Mention Rate',
      subtitle: 'Brand mention rate across all analyzed responses.',
      detailedCaption: '{{mentions}} mentions in {{responses}} responses',
    },
    citationRate: {
      title: 'Citation Rate',
      subtitle: 'Share of responses citing the brand compared with competitors.',
      averageLabel: 'average citation rate',
      detailedCaption: '{{citations}} citations · {{responses}} responses',
    },
    competitorHeatmap: {
      title: 'Competitor Heatmap',
      subtitle: 'Topic-level visibility by competitor across mentions and citations.',
      metric: {
        mention: 'Mention',
        citation: 'Citation',
      },
    },
    positiveTraits: {
      title: 'Positive Traits',
      subtitle: 'How often the brand is associated with positive attributes.',
    },
    negativeTraits: {
      title: 'Negative Traits',
      subtitle: 'How often the brand is associated with negative attributes.',
    },
    traitsView: {
      radar: 'Radar',
      trend: 'Trend',
    },
    traitsLegend: {
      competitors: 'Competitors',
    },
    legend: {
      competitor: 'Competitor',
    },
    showRelative: 'Show Relative',
    showAbsolute: 'Show Absolute',
    toggle: {
      detailed: 'Detailed',
      simple: 'Simple',
    },
    traitsTable: {
      trait: 'Trait',
      you: 'You',
      comp: 'Comp',
    },
    traitNames: {
      dianCompliance: 'DIAN Compliance',
      latinFocus: 'Latin Focus',
      mobileManagement: 'Mobile Management',
      assetTracking: 'Asset Tracking',
      financialSimplicity: 'Financial Simplicity',
      manualFocus: 'Manual Focus',
      manualRecords: 'Manual Records',
      socialSelling: 'Social Selling',
      agile: 'Agile',
      collaborative: 'Collaborative',
      customerCentric: 'Customer-Centric',
      dataDriven: 'Data-Driven',
      efficient: 'Efficient',
      outcomeOriented: 'Outcome-Oriented',
      scalable: 'Scalable',
      strategic: 'Strategic',
      trusted: 'Trusted',
      bureaucratic: 'Bureaucratic',
      overpromising: 'Overpromising',
      priceDriven: 'Price-Driven',
      reactive: 'Reactive',
      riskAverse: 'Risk-Averse',
      highQuality: 'High Quality',
      innovative: 'Innovative',
      goodDisplay: 'Good Display',
      featureRich: 'Feature Rich',
      premiumDesign: 'Premium Design',
      wideRange: 'Wide Range',
      smartFeatures: 'Smart Features',
      reliable: 'Reliable',
      goodForSports: 'Good for Sports',
      energyEfficient: 'Energy Efficient',
      expensive: 'Expensive',
      complexSetup: 'Complex Setup',
      bloatware: 'Bloatware',
      premiumOnly: 'Premium Only',
      shortUpdates: 'Short Updates',
      fragileScreen: 'Fragile Screen',
      slowSupport: 'Slow Support',
      heavy: 'Heavy',
      overkill: 'Overkill Features',
      limitedBudget: 'Limited Budget Options',
      accurate: 'Accurate',
      affordable: 'Affordable',
      extensive: 'Extensive',
      fast: 'Fast',
      localized: 'Localized',
      multiSource: 'Multi-Source',
      transparent: 'Transparent',
      versatile: 'Versatile',
      complex: 'Complex',
      fragmented: 'Fragmented',
      inaccurate: 'Inaccurate',
      inconsistent: 'Inconsistent',
      limited: 'Limited',
      opaque: 'Opaque',
      slow: 'Slow',
      unreliable: 'Unreliable',
      unresponsive: 'Unresponsive',
      outdated: 'Outdated',
      aiAppliedToHr: 'AI Applied to HR',
      integratedPlatform: 'Integrated Platform',
      argentineCompliance: 'Argentine Compliance',
      localSupport: 'Local Support',
      enterpriseSecurity: 'Enterprise Security',
      implementationSpeed: 'Implementation Speed',
      functionalDepth: 'Functional Depth',
      provenScale: 'Proven Scale',
      vismaWayConfusion: 'Visma Way Confusion',
      enterpriseOnly: 'Enterprise Only',
      slowImplementation: 'Slow Implementation',
      rigidProduct: 'Rigid Product',
      legacyInterface: 'Legacy Interface',
      mobileLackingFocus: 'Limited Mobile Focus',
      bureaucraticSupport: 'Bureaucratic Support',
      freemiumVersion: 'Free / freemium plan',
      simpleOperation: 'Simple, easy to use',
      mobileFirst: 'Mobile-first app',
      closeHumanSupport: 'Close human support',
      latamCoverage: 'LatAm coverage',
      industryVerticals: 'Industry verticals',
      allInOnePlatform: 'All-in-one platform',
      financialInclusion: 'Financial inclusion',
      technicalBugs: 'Bugs / technical friction',
      barcodeScanIssues: 'Barcode scanner issues',
      freeTierLimits: 'Free tier limits',
      limitedEInvoicing: 'Limited e-invoicing',
      lackOfIntegrations: 'Lack of integrations / ERP',
      notForLargeBusiness: 'Not for large businesses',
      learningCurve: 'Learning curve',
      fintechSpecialization: 'Fintech Specialization',
      flutterExpertise: 'Flutter Expertise',
      nicheFocus: 'Niche Focus',
      uiUxFocus: 'UI/UX Focus',
      budgetFocus: 'Budget Focus',
      codeQuality: 'Code Quality',
      crossPlatformConcerns: 'Cross-Platform Concerns',
      nearshorePresence: 'Nearshore Presence',
    },
  },
  prompts: {
    title: 'Prompts',
    description:
      'Analysis of prompts grouped by topic, summaries, and response metrics.',
    filters: {
      trigger: 'Filters',
      search: 'Search prompts',
      status: 'Status',
      topic: 'Topic',
      tag: 'Tag',
      language: 'Language',
      competition: 'Competition',
      all: 'All',
      clearFilters: 'Clear filters',
      dateFrom: 'From',
      dateTo: 'To',
      dateRange: 'Date range',
      applyFilters: 'Apply filters',
    },
    columns: {
      prompt: 'Prompt',
      topic: 'Topic',
      tags: 'Tags',
      status: 'Status',
      mentionPercent: 'Mention %',
      mentionGap: 'Mention Gap',
      competitorMentionPercent: 'Competitor Mention %',
      citationPercent: 'Citation %',
      citationGap: 'Citation Gap',
      competitorCitationPercent: 'Competitor Citation %',
      sentimentPercent: 'Sentiment %',
      avgPosition: 'Avg Position',
      mentionChange: 'Mention Change',
      sentimentChange: 'Sentiment Change',
      impressions: 'Impressions',
      competition: 'Competition',
      monthlySearches: 'Monthly Searches',
      totalValue: 'Total Value',
      estimatedValueCaptured: 'Est. Value Captured',
      language: 'Language',
      personas: 'Personas',
      totalResponses: 'Total Responses',
      createdAt: 'Created At',
    },
    actions: {
      viewResponses: 'View responses',
      dateRange: 'Date Range',
      views: 'Views',
      addMore: 'Add More',
      openMenu: 'Open actions menu',
      selectVisible: 'Select visible prompts',
    },
    ui: {
      total: 'Total:',
      noMatchingPrompts: 'No prompts match the selected filters.',
      showingCount: 'Showing {{visible}} of {{total}} prompts (and {{variations}} variations)',
      comparedTo: 'compared to',
      selectPeriod: 'Select period...',
      loading: 'Loading prompts...',
      error: 'Failed to load prompts. Please try again.',
    },
    drawer: {
      metrics: {
        responsesAnalyzed: 'Responses Analyzed',
        sourcesTracked: 'Sources Tracked',
        attributedCitations: 'Attributed Citations',
      },
      charts: {
        shareOfVoice: 'Share of Voice',
        shareOfVoiceDesc: 'How often AI mentions your brand vs competitors',
        shareOfVoiceByModel: 'Share of Voice by Model',
        shareOfVoiceByModelDesc: "Your brand's visibility on each AI model",
        mentionRate: 'Mention Rate',
        mentionRateDesc: 'Your share of mentions in relevant responses',
        mentionRateAverage: 'average mention rate',
        citationRate: 'Citation Rate',
        citationRateDesc: 'How often AI cites your content',
        citationRateAverage: 'average citation rate',
        positionOverTime: 'Position over Time',
        positionOverTimeDesc: 'Track your ranking in AI responses over time',
        dailyShareOfVoice: 'Daily Share of Voice',
        dailyShareOfVoiceDesc: 'Daily Share of Voice trends over time',
        noData: 'No data',
        averagePosition: 'average position',
      },
      variations: {
        title: 'Prompt Variations',
        total: '{{count}} total',
        columns: {
          type: 'Type',
          text: 'Prompt text',
        },
        types: {
          base: 'Base Prompt',
          variation: 'Variation',
        },
      },
      actions: {
        expand: 'Expand drawer',
        close: 'Close',
      },
    },
  },
  responses: {
    title: 'Responses',
    description:
      'Response visibility with prompt-linked navigation and functional filters by model, citation, and source presence.',
    filters: {
      trigger: 'Filters',
      search: 'Response search',
      prompt: 'Topics & Prompts',
      promptType: 'Prompt Type',
      model: 'Model',
      mentioned: 'Mentioned',
      cited: 'Cited',
      attributedCitation: 'Attributed Citation',
      all: 'All',
      allPrompts: 'All prompts',
      allPromptTypes: 'All prompt types',
      allModels: 'All models',
      clearFilters: 'Clear filters',
      applyFilters: 'Apply filters',
      dateFrom: 'From',
      dateTo: 'To',
      dateRange: 'Date range',
      yes: 'Yes',
      no: 'No',
    },
    columns: {
      date: 'Date',
      model: 'Model',
      mentioned: 'Mentioned',
      competitorsMentioned: 'Competitors Mentioned',
      sources: 'Sources',
      cited: 'Cited',
      attributedCitation: 'Attributed Citation',
      promptType: 'Prompt Type',
      basePrompt: 'Prompt',
      promptVariation: 'Prompt Variation',
      country: 'Country',
      response: 'Response',
    },
    actions: {
      views: 'Views',
    },
    drawer: {
      title: 'Response details',
      promptAndResponse: 'Prompt & Response',
      basePrompt: 'Base Prompt',
      competitors: 'Competitors Mentioned',
      sources: 'Sources',
      fullResponse: 'Response',
      noSources: 'No sources',
    },
    ui: {
      total: 'Total:',
      filteredPromptLabel: 'Prompt',
      showingCount: 'Showing {{visible}} of {{total}} responses',
      loading: 'Loading responses...',
      error: 'Failed to load responses. Please try again.',
      noMatchingResponses: 'No responses match the selected filters.',
      loadMore: 'Load More',
      entireExportLoaded: 'Entire export loaded',
      filteredFromResponses: 'Filtered from {{total}} total responses',
    },
  },
  sources: {
    title: 'Data Sources',
    description:
      'Analysis of sources with sortable domains, source types, and influence metrics.',
    modes: {
      domain: 'Domain',
      page: 'Page',
      all: 'All',
      social: 'Social',
    },
    social: {
      all: 'All',
      less: 'Less',
      more: 'More',
      noData: 'No data for current filters',
    },
    filters: {
      type: 'Type',
      mentioned: 'Mentioned',
      minCitation: 'Min Citation %',
      minResponses: 'Min Responses',
      all: 'All',
      thirdParty: 'Third party',
      competitor: 'Competitor',
      yes: 'Yes',
      no: 'No',
      clearFilters: 'Clear filters',
      dateFrom: 'From',
      dateTo: 'To',
      dateRange: 'Date range',
      applyFilters: 'Apply filters',
    },
    columns: {
      rank: '#',
      domain: 'Domain',
      page: 'Page',
      sparkchart: 'Sparkchart',
      type: 'Type',
      citationPercent: 'Citation %',
      citations: 'Citations',
      responsesInfluenced: 'Responses Influenced',
      impressionsCaptured: 'Impressions Captured',
      brandMentionPercent: 'Brand mention %',
      competitorMentionPercent: 'Competitor Mention %',
      urls: 'URLs',
    },
    ui: {
      dateRange: 'Date Range',
      searchDomains: 'Search Domains',
      searchUrls: 'Search URLs',
      tags: 'Tags',
      views: 'Views',
      showingCountDomains: 'Showing {{displayed}} of {{total}} Domains',
      showingCountPages: 'Showing {{displayed}} of {{total}} URLs',
      updatingFilters: 'Updating filters...',
      loadMore: 'Load More',
      entireExportLoaded: 'Entire export loaded',
      filteredFromDomains: 'Filtered from {{total}} total domains',
      filteredFromPages: 'Filtered from {{total}} total URLs',
      noMatchingSources: 'No sources match the selected filters.',
      error: 'Failed to load sources. Please try again.',
      filteredByPrompt: 'Filtered by prompt:',
      clearPromptFilter: 'Clear prompt filter',
      urlsTooltip: '{{count}} unique URLs indexed for {{domain}}',
    },
    analytics: {
      trigger: 'View analytics',
      title: 'Analytics',
      subtitle: 'Breakdown of citations for {{domain}}.',
      close: 'Close analytics drawer',
      citationRateTitle: 'Citation Rate Over Time',
      citationRateDescription:
        'Percentage of responses citing this source over time.',
      urlBreakdown: 'URL Breakdown',
      promptBreakdown: 'Prompt Breakdown',
      empty: 'No data for the current filters.',
      showingUrls: 'Showing {{count}} of {{total}} URLs',
      showingPrompts: 'Showing {{count}} of {{total}} prompts',
      columns: {
        url: 'URL',
        prompt: 'Prompt',
        mentioned: 'Mentioned',
        competitors: 'Competitors Mentioned',
        firstSeen: 'First Seen',
        citationPercent: 'Citation %',
        domainPercent: 'Domain %',
        citations: 'Citations',
      },
      filters: {
        dateRange: 'Date Range',
        topicsPrompts: 'Topics & Prompts',
        mentioned: 'Mentioned',
        cited: 'Cited',
        model: 'Model',
        addFilter: 'Add filter',
        clearAll: 'Clear All',
        apply: 'Apply',
        reset: 'Reset',
        selectPlaceholder: 'Select...',
        searchPromptsPlaceholder: 'Search prompts...',
        noPromptsMatch: 'No prompts match your search.',
        countSelected: '{{count}} selected',
        operatorIs: 'is',
        operatorIsAnyOf: 'is any of',
        optionAny: 'Any',
        optionYes: 'Yes',
        optionNo: 'No',
        removeFilter: 'Remove filter',
        clearShort: 'Clear',
      },
    },
  },
  placeholder: {
    badge: 'Preview',
    status: 'This section is available only for {{brand}} right now.',
    cardTitle: 'Coming soon',
    cardDescription:
      'The foundation for this module is ready. The next iteration can connect real data, prompts, and sources.',
  },
  actions: {
    title: 'Actions',
    tabs: {
      content: 'Content Opportunities',
      forums: 'Forum Threads',
      gaps: 'Topic Gaps',
    },
    priority: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    filters: {
      all: 'All',
      allPriorities: 'All priorities',
      allPlatforms: 'All platforms',
      allThreads: 'All threads',
    },
    content: {
      count: '{{visible}} of {{total}} opportunities',
      empty: 'No opportunities match the current filters.',
      columns: {
        opportunity: 'Opportunity',
        source: 'Source',
        priority: 'Priority',
        citations: 'Citations',
        responses: 'Responses',
        topic: 'Topic',
        action: 'Suggested action',
      },
      source: {
        competitor: 'Competitor',
        thirdParty: 'Third-party',
      },
      action: {
        create_better_content: 'Create better content',
        pitch_guest_post: 'Pitch guest post',
        outreach_mention: 'Request a mention',
      },
    },
    forums: {
      count: '{{visible}} of {{total}} threads',
      empty: 'No threads match the current filters.',
      brandMentionedShort: 'Mentioned',
      brandMissingShort: 'Not mentioned',
      columns: {
        thread: 'Thread',
        priority: 'Priority',
        brand: '{{brand}}',
        responses: 'Responses',
        engagement: 'Engagement',
        lastActivity: 'Activity',
        action: 'Suggested action',
      },
      platform: {
        reddit: 'Reddit',
        mercadolibre_qa: 'Mercado Libre Q&A',
        taringa: 'Taringa',
        forocoches: 'ForoCoches',
        stackexchange: 'Stack Exchange',
        elhacker: 'ElHacker',
      },
      action: {
        reply_thread: 'Reply in thread',
        create_thread: 'Create thread',
        monitor_thread: 'Monitor',
      },
    },
    gaps: {
      count: '{{visible}} of {{total}} gaps',
      empty: 'No topic gaps match the current filters.',
      totalArticles: '{{value}} articles suggested',
      columns: {
        topic: 'Topic',
        priority: 'Priority',
        brand: '{{brand}}',
        competitor: 'Top competitor',
        gap: 'Gap',
        searches: 'Searches / mo',
        articles: 'Articles',
      },
      sort: {
        gap: 'Biggest gap',
        searches: 'Most searched',
      },
    },
    geo: {
      tabs: {
        editorial: 'Editorial',
        forums: 'Forums',
        external: 'External assets',
        listings: 'Listings & reviews',
        content: 'Content opportunities',
      },
      common: {
        empty: 'No rows match the current filters.',
        searchPlaceholder: 'Search…',
        visibleCount: '{{visible}} of {{total}}',
        loadMore: 'Load more',
        filterAll: 'All',
        filterMentioned: 'Mention {{brand}}',
        filterNotMentioned: 'No mention',
        mentionedYes: 'Mentioned',
        mentionedNo: 'Not mentioned',
        cols: {
          citations: 'Citations',
          impressions: 'Impressions',
          mentions: 'Mentions {{brand}}',
          competitors: 'Competitors cited',
          action: 'Suggested action',
        },
      },
      editorial: {
        intro:
          'Editorial sources cited in responses — press outlets and encyclopedia entries. Audit coverage and run PR to influence the narrative.',
        filterAll: 'All sources',
        filterPress: 'Press',
        filterWiki: 'Wiki',
        kindPress: 'Press',
        onDomain: 'On domain',
        urlsCount: '{{count}} URLs',
        kpi: {
          sources: 'Sources',
          sourcesHint: '{{press}} press · {{wiki}} wiki',
          citations: 'Total citations',
          impressions: 'Impressions / mo',
          coverage: 'Mention {{brand}}',
        },
        cols: {
          source: 'Source / cited URL',
          type: 'Type',
        },
      },
      forums: {
        platformsTitle: 'Platforms',
        allPlatforms: 'All platforms',
        threadCount: '{{count}} threads',
        allOverview:
          'Showing threads across every platform. Pick one on the left to focus and see its detail.',
        kpi: {
          platforms: 'Platforms',
          threads: 'Threads',
          citations: 'Total citations',
          coverage: 'Threads mentioning {{brand}}',
          impressionsHint: '{{impressions}} impressions / mo',
          perMonth: 'monthly',
        },
        cols: {
          platform: 'Platform',
          urls: 'Distinct URLs',
          thread: 'Thread',
          topic: 'Topic',
        },
      },
      external: {
        allPlatforms: 'All platforms',
        kpi: {
          assets: 'Assets',
          platforms: 'Platforms',
          citations: 'Total citations',
          impressionsHint: '{{impressions}} impressions / mo',
          mentioning: 'Mention {{brand}}',
        },
        cols: {
          platform: 'Platform',
          url: 'URL',
          topic: 'Topic',
        },
      },
      listings: {
        allPlatforms: 'All platforms',
        allActions: 'All actions',
        kpi: {
          listings: 'Listings',
          platforms: 'Platforms',
          citations: 'Total citations',
          mentioning: 'Mention {{brand}}',
        },
        cols: {
          platform: 'Platform',
          url: 'URL',
          pageType: 'Page type',
          category: 'Category',
        },
      },
      content: {
        allCompetitors: 'All competitors',
        filterAllTypes: 'All types',
        filterEditorial: 'Editorial',
        filterProduct: 'Product / category',
        kpi: {
          opportunities: 'Opportunities',
          competitors: 'Competitors',
          citations: 'Total citations',
          impressionsHint: '{{impressions}} impressions / mo',
          editorial: 'Editorial',
        },
        cols: {
          competitor: 'Competitor',
          url: 'Cited URL',
          type: 'Type',
          topic: 'Topic',
          suggestedContent: 'Suggested content for {{brand}}',
        },
      },
    },
  },
} as const
